import {CmsSharedKeys, SharedKeys, DarklySharedKeys} from 'epic-fortnite-shared-values';

import {SACStatus} from '../server/handlers/creative-form/creative.types';

import {SharedValuesState} from './shared.types';

export const AppSharedKeys: SharedKeys<SharedValuesState> = {
  ...CmsSharedKeys,
  ...DarklySharedKeys,
  SubmitIslandStore: {
    id: 'SubmitIslandStore',
    defaultValue: {SACStatus: {} as SACStatus, islands: []},
  },
};
